/** Parse filename from axios response (matches backend attachment; filename="…"). */
export function filenameFromContentDisposition(res, fallback) {
  const cd = res.headers?.['content-disposition'];
  if (!cd || typeof cd !== 'string') return fallback;
  const m = cd.match(/filename="([^"]+)"/i);
  return m ? m[1] : fallback;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
